import { manageAttributeCssClasses as e, moveArrayItem as D } from "helper-functions-library";
import '../../assets/UpDownButtons.css';const E = "op_rankingButton_Uey9I", I = "op_chevron_apZs-", y = "op_chevronDown_BjpX8", G = "op_buttonHolder_uJ6ee", U = "op_placeHolder_Gneg2", o = {
  rankingButton: E,
  chevron: I,
  chevronDown: y,
  buttonHolder: G,
  placeHolder: U
}, l = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Uploaded%20to:%20SVG%20Repo,%20www.svgrepo.com,%20Generator:%20SVG%20Repo%20Mixer%20Tools%20--%3e%3csvg%20fill='currentColor'%20width='25px'%20height='25px'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3ctitle%3echevron-up%3c/title%3e%3cpolygon%20points='21.1%2018.7%2012%209.6%202.9%2018.7%200.1%2015.8%2012%203.9%2023.9%2015.8%2021.1%2018.7'/%3e%3c/svg%3e";
function V(c) {
  let {
    index: t,
    settings: n,
    setSettings: r,
    holderAttributes: a,
    downButtonAttributes: u,
    upButtonAttributes: i,
    downImgAttributes: p,
    upImgAttributes: d,
    placeHolderAttributes: g
  } = c, m = e({ defaultClasses: o.buttonHolder, attributes: a }), v = e({ defaultClasses: o.rankingButton, attributes: u }), w = e({ defaultClasses: o.rankingButton, attributes: i }), b = e({ defaultClasses: o.chevronDown, attributes: p }), h = e({ defaultClasses: o.chevron, attributes: d }), A = e({ defaultClasses: o.placeHolder, attributes: g });
  function s(k, x) {
    let R = D(n, k, x);
    r !== void 0 && r(R);
  }
  const B = t - 1, f = t + 1, C = /* @__PURE__ */ React.createElement("button", { onClick: () => s(t, B), ...w }, /* @__PURE__ */ React.createElement("img", { src: l, alt: "chevron", title: "click to move up", ...h })), H = /* @__PURE__ */ React.createElement("button", { onClick: () => s(t, f), ...v }, /* @__PURE__ */ React.createElement("img", { src: l, alt: "chevron", title: "click to move down", ...b })), _ = /* @__PURE__ */ React.createElement("span", { ...A });
  return /* @__PURE__ */ React.createElement("div", { ...m }, t > 0 ? C : "", t != n.length - 1 ? H : _);
}
export {
  V as UpDownButtons
};
